import { Factory } from '../../../lib/api';
const getTeamCells = (teamId, params) => Factory.get(`api/v1/teams/${teamId}/cells`, params);
export default getTeamCells;
